
import * as React from 'react'
import {Link, useIntl} from 'gatsby-plugin-react-intl'
import {getActiveMonth, getMonthIndexFromName, InitialStateType, useSelectedMonthContext} from 'context/SelectedMonthContext'
import { useLocation } from '@reach/router';
import { monthSlugsWithOverview as monthSlugs, months } from 'services/centralStore'
import isBrowser from 'services/isBrowser';
import ensureMonthIndexInRange from 'services/ensureMonthIndexInRange'

export const DestinationMonthPicker = ({slug}: {slug: string}) => {
    const intl = useIntl()
    let [monthStates, dispatch] = useSelectedMonthContext();
    let [monthsToRender, setMonthsToRender] = React.useState([] as {month: keyof InitialStateType, idx?: number}[]);
    const { pathname } = useLocation();
    const handleClick = (x: keyof InitialStateType) => {
        dispatch({type: 'SET_ACTIVE_MONTH', selectedMonthName: monthStates[x].name})
    }
    let resizeTimeout: any = null;
    const onResize = () => {

        if (!isBrowser()) return;
        if (resizeTimeout) clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
            let width = window.innerWidth;
            if (width > 1560) {
                if (monthsToRender.length <= 12) {
                    setMonthsToRender([...months, 'all'].map((m, idx) => { return { month: m } }));
                }
                return;
            }
            let activeMonth = getActiveMonth(monthStates);
            let activeMonthIndex = getMonthIndexFromName(activeMonth.name);
            if (activeMonth.name == 'all') {
                activeMonthIndex = new Date().getMonth() + 1;
            }
            let idxs = [-2, -1, 1, 2].map((diff) => ensureMonthIndexInRange(activeMonthIndex + diff));
            let keys;
            if (width < 800) {
                keys = [months[idxs[1]], 'all', months[idxs[2]]].map((m, idx) => { return { month: m, idx: idx - 1 } });
            }
            else {
                keys = [months[idxs[0]], months[idxs[1]], 'all', months[idxs[2]], months[idxs[3]]].map((m, idx) => { return { month: m, idx: idx - 2 } });
            }
            if (monthsToRender.length != keys.length) {
                setMonthsToRender(keys);
            }
        },20)
        
    }
    React.useEffect(() => {
        if (!isBrowser()) return;
        setTimeout(onResize, 1);
        window.addEventListener('resize', onResize)
        return () => window.removeEventListener('resize', onResize)
    })

    return (<div className="destination__month_picker_wrapper">
        {/*<button type="button"
                 className={`destination__month_picker`}> Vše</button>*/}
        {monthsToRender.map((x) =>
        (<Link key={`${monthStates[x.month].name}`}
                    className={`destination__month_picker ${monthStates[x.month].selected && 'destination__month_picker--selected'}`}
            to={pathname.split('-').slice(0, -1).join('-') + `-` + monthSlugs[getMonthIndexFromName(monthStates[x.month].name)] + '/' }
                    onClick={()=>handleClick(x.month)}
            >
            {
                (x.idx < 0 ? getArrowsFromIndex(x.idx) : '') + intl.formatMessage({ id: `common.months.${monthStates[x.month].name}` }) + (x.idx>0 ? getArrowsFromIndex(x.idx) : '')
            }</Link>)
        
        )}
    </div>)
}

const getArrowsFromIndex = (idx: number) => {
    if (!idx) return '';
    switch (idx) {
        case -2: return '<< ';
        case -1: return '< ';
        case 1: return ' >';
        case 2: return ' >>';
    }
}